import {override, computed} from "mobx";
import {ScoresBarWidgetScoresModel} from "./scores-bar-widget.scores.model";
import {BaseLinkModel} from "../../../../infrastructure/models/link/base-link-model";
import {EntityScoresWidgetDropdownItemViewModel} from "../../../entity-scores-widget/models/entity-scores-widget.dropdown-item.view-model";
import {ENTITY_SCORES} from "../../../entity-scores-widget/entity-scores-widget.consts";
import {CompetitorLinkModel} from "../../../../containers/competitor-container/models/competitor-link-model";

export class ScoresBarWidgetCompetitorScoresModel extends ScoresBarWidgetScoresModel {
  @override get entityId(): Number {
    return Number(this.currentLinkModel?.params.id)
  }

  @override get linkType(): CompetitorLinkModel {
    return CompetitorLinkModel
  }

  @override get linkModel(): BaseLinkModel {
    return null
  }

  @override get shouldRenderLiveToggle(): Boolean {
    return false
  }

  @override get hasDropdown(): Boolean {
    return true;
  }

  @override get shouldRenderDate(): Boolean {
    return false;
  }

  @computed get filterDropdown(): Array<EntityScoresWidgetDropdownItemViewModel> {
    const items: Array<EntityScoresWidgetDropdownItemViewModel> = ENTITY_SCORES.FILTERS_ARRAY.map((option, index: Number) => {
      if (this.terms) {
        option.name = this.terms[option.termKey];
        option.toString = () => this.terms[option.termKey];
      }

      const item = {
        id: index,
        key: option.key,
        name: option.name,
        active: index === this.currentFilterIndex
      }

      return item;
    });

    return items;
  }

  @computed get selectedDropdownFilter(): EntityScoresWidgetDropdownItemViewModel {
    const selectedDropdownFilter = this.filterDropdown.find(item => item.active);

    return selectedDropdownFilter;
  }

  @computed get shouldRenderDropdown() {
    return this.hasDropdown && this.filterDropdown?.length > 0;
  }
}
